import { reportError } from './ErrorReporting';
import presignedUrlsActions from '../actions/PresignedUrlsActions';
import storeManager from '../store/StoreManager';
import apiService from './api/ApiService';
import environmentNames from '../qti/environmentNames';
import settingsReader from '../store/readHelpers/SettingsReader';

function getPresignUrlValidityAsMilliseconds() {
    return settingsReader.getPlayerMediaPresignedUrlLifetimeHours() * 1000 * 60 * 60;
}

const inflightPresignPromises = {};

const presignUrlService = {
    isValidPresignedUrl(existingPresignedUrl, nowTimestamp = Date.now(), urlValidity = getPresignUrlValidityAsMilliseconds()) {
        if (!existingPresignedUrl) {
            return false;
        }
        if (existingPresignedUrl.timestamp && existingPresignedUrl.timestamp < (nowTimestamp - urlValidity)) {
            // Presigned url has expired
            return false;
        }
        return !!existingPresignedUrl.presignedUrl;
    },
    fetchPresignedUrl(url) {
        const urlParam = `${url.indexOf('?') > 0 ? '&' : '?'}getPresignedUrl=true`;
        return apiService
            .getPresignedURLFromFileServletUrl(url + urlParam);
    },
    loadPresignedUrl(identifier, url) {
        const { dispatch } = storeManager.getStore();
        const { presignedUrls } = storeManager.getState();

        if (process.env.NODE_ENV === environmentNames.DEVELOPMENT) {
            return false;
        }

        const existingPresignedUrl = presignedUrls[identifier];

        if (this.isValidPresignedUrl(existingPresignedUrl)) {
            return Promise.resolve(existingPresignedUrl.presignedUrl);
        }
        if (inflightPresignPromises[identifier]) {
            return inflightPresignPromises[identifier];
        }

        inflightPresignPromises[identifier] = this.fetchPresignedUrl(url)
            .then((response) => {
                dispatch(
                    presignedUrlsActions.setPresignedUrl(
                        identifier,
                        response.presignedAWSUrl,
                    ),
                );
                delete inflightPresignPromises[identifier];
                return response.presignedAWSUrl;
            })
            .catch((ex) => {
                reportError(ex);
                // lying about having presigned url and setting the original as it works in many browsers
                dispatch(
                    presignedUrlsActions.setPresignedUrl(
                        identifier,
                        url,
                    ),
                );
                delete inflightPresignPromises[identifier];
                return url;
            });
        return inflightPresignPromises[identifier];
    },
};

export default presignUrlService;
